import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { api } from '../consts/url';
import { PanicContactGroupModels } from '../models/contact-group.model';

@Injectable({ providedIn: 'root' })
export class ContactGroupsService {
  private readonly http = inject(HttpClient);

  public getContactGroups(): Observable<
    PanicContactGroupModels.ContactGroupDocument[]
  > {
    return this.http.get<PanicContactGroupModels.ContactGroupDocument[]>(
      api.contactGroups.all,
    );
  }

  public getMembers(
    groupId: string,
  ): Observable<PanicContactGroupModels.MembersResponse> {
    return this.http.get<PanicContactGroupModels.MembersResponse>(
      api.contactGroups.members(groupId),
    );
  }

  public create(
    dto: PanicContactGroupModels.ContactGroupCreateDto,
  ): Observable<PanicContactGroupModels.ContactGroupDocument> {
    return this.http.post<PanicContactGroupModels.ContactGroupDocument>(
      api.contactGroups.create,
      {
        name: dto.name,
        note: dto.note,
        contactIds: dto.contactIds ?? [],
        orgUserIds: dto.orgUserIds ?? [],
      },
    );
  }

  public update(
    id: string,
    dto: PanicContactGroupModels.ContactGroupUpdateDto,
  ): Observable<PanicContactGroupModels.ContactGroupDocument> {
    return this.http.put<PanicContactGroupModels.ContactGroupDocument>(
      api.contactGroups.update(id),
      {
        name: dto.name,
        note: dto.note,
      },
    );
  }

  public updateMembers(
    id: string,
    dto: PanicContactGroupModels.MembersUpdateDto,
  ): Observable<PanicContactGroupModels.ContactGroupDocument> {
    return this.http.put<PanicContactGroupModels.ContactGroupDocument>(
      api.contactGroups.members(id),
      {
        contactIds: dto.contactIds,
        orgUserIds: dto.orgUserIds,
      },
    );
  }

  public removeMember(
    groupId: string,
    memberId: string,
    memberType: PanicContactGroupModels.MemberType,
  ): Observable<PanicContactGroupModels.ContactGroupDocument> {
    const body =
      memberType === PanicContactGroupModels.MemberType.CONTACT
        ? { contactId: memberId }
        : { orgUserId: memberId };
    return this.http.post<PanicContactGroupModels.ContactGroupDocument>(
      api.contactGroups.removeMember(groupId),
      body,
    );
  }

  public delete(id: string): Observable<void> {
    return this.http.delete<void>(api.contactGroups.delete(id));
  }
}
